import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FuseSidebarModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';

import { ContentModule } from 'app/layout/components/content/content.module';
import { FooterModule } from 'app/layout/components/footer/footer.module';
import { NavbarModule } from 'app/layout/components/navbar/navbar.module';
import { ToolbarModule } from 'app/layout/components/toolbar/toolbar.module';

import { UserSettingsPanelModule } from 'app/main/user/settings/user-settings.module';

import { DefaultLayoutComponent } from 'app/layout/default-layout/default-layout.component';

@NgModule({
    declarations: [
        DefaultLayoutComponent
    ],
    imports     : [
        RouterModule,

        FuseSharedModule,
        FuseSidebarModule,

        ContentModule,
        FooterModule,
        NavbarModule,
        ToolbarModule,
        UserSettingsPanelModule
    ],
    exports     : [
        DefaultLayoutComponent
    ]
})
export class DefaultLayoutModule
{
}
